<template>
  <div class="page">
    <SearchNav />
    <div class="page-content">
      <div class="page-title-container">
        <img class="page-icon" :src="require('@/assets/img/logo.png')" />
        <div class="page-title">找他人代付</div>
      </div>
      <div class="content-card">
        <div class="description">请将此二维码拍照或截图转发给付款人，注意，该二维码包含订单等重要信息，请谨慎转发</div>
        <div class="qr-code-container">
          <div class="wechat-description">请使用微信扫一扫</div>
          <img class="qr-code" :src="qrCodeUrl" />
          <div class="deadline">请在{{ validity }}前支付</div>
        </div>
        <a class="a-button" @click="goBack">返回</a>
      </div>
    </div>
  </div>
</template>

<script>
import SearchNav from '@/components/SearchNav/index.vue'
import * as api from '@/services'

export default {
  name: 'PayOnBehalf',
  components: { SearchNav },
  data() {
    return {
      qrCodeUrl: null,
      validity: '-',
    }
  },
  computed: {
    orderSn() {
      return this.$route.params.orderSn;
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      const res = await api.crm.getOrderShareInfo({
        bizOrderSn: this.orderSn
      })
      this.qrCodeUrl = res.qrCodeUrl
      this.validity = res.validity
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  //height: calc(100% - 34px);
}
.page-content {
  width: 100%;
  background: #f4f4f4;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 40px);
}
.page-title-container {
  display: flex;
  width: 1190px;
  margin: 16px 0;
  .page-icon {
    width: 81px;
    height: 24px;
    margin-right: 8px;
  }
  .page-title {
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
  }
}
.content-card {
  width: 1190px;
  height: 759px;
  background: #ffffff;
  border-radius: 8px;
  padding: 27px 24px 44px 24px;
  margin-bottom: 54px;
  .description {
    font-size: 18px;
    color: #333333;
    line-height: 18px;
    margin-bottom: 42px;
  }
  .qr-code-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .wechat-description {
      font-size: 24px;
      font-weight: 500;
      margin-bottom: 12px;
    }
    .qr-code {
      width: 389px;
      height: 389px;
      margin-bottom: 18px;
    }
    .deadline {
      width: 389px;
      height: 84px;
      background: #1e8dff;
      text-align: center;
      line-height: 84px;
      margin-bottom: 72px;
      color: #fff;
      font-size: 18px;
    }
  }
  .a-button {
    display: block;
    width: 100%;
    text-align: center;
    font-size: 18px;
    line-height: 18px;
    color: #1e8dff;
    cursor: pointer;
  }
}
</style>

